module.exports = (__webpack_require__(9))(7);


//////////////////
// WEBPACK FOOTER
// delegated ./assets/js/fields/decorators/with-setup.js from dll-reference carbon.core
// module id = 57
// module chunks = 0